import React from 'react';
import { Bot } from 'lucide-react';

// Full-screen loader shown while the claim form waits for the API.
const ClaimLoader = ({ text }) => (
    <div className="fixed inset-0 bg-primary bg-opacity-80 flex flex-col justify-center items-center z-50 backdrop-blur-sm">
        <div className="relative flex justify-center items-center mb-6">
            <div className="absolute w-16 h-16 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            <Bot className="text-white h-6 w-6" />
        </div>
        <p className="text-white text-sm uppercase tracking-widest font-semibold">{text}</p>
    </div>
);

export default ClaimLoader;
